import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-item-modern',
  templateUrl: './product-item-modern.component.html',
  styleUrls: ['./product-item-modern.component.css']
})
export class ProductItemModernComponent implements OnInit {

  @Input()
  product:any;

  public urlHost = "";
  constructor() {
    this.urlHost = environment.urlHostImage;
   }

  ngOnInit() {
  }

}
